import React from 'react';
import { Container, Grid, Flex, Text } from 'basis';
import { calculatedTotalMonthlyExpenses } from 'utils/expensesFooterHelper';
import { LayoutContent } from 'components';
import { byCountry, isNZ } from 'utils/byConfig';
import { device } from 'media';
import { formatNumber } from 'utils/formatNumber';
import styled from '@emotion/styled';

const StickToBottom = styled.div`
  @media ${device.mobileOrSmaller} {
    position: sticky;
    bottom: 0;
    z-index: 999;
  }
`;

const StickOrNot = isNZ() ? styled.div() : StickToBottom;

export const ExpensesFooter = ({ values }) => {
  const totalMonthlyExpenses = calculatedTotalMonthlyExpenses(values);

  return (
    <StickOrNot>
      <Container>
        {byCountry({
          NZ: <NZV2ExpenseFooter totalMonthlyExpenses={totalMonthlyExpenses} />,
          AU: <AUExpenseFooter totalMonthlyExpenses={totalMonthlyExpenses} />,
        })}
      </Container>
    </StickOrNot>
  );
};

const AUExpenseFooter = ({ totalMonthlyExpenses }) => (
  <LayoutContent>
    <Container
      margin="4 0"
      padding="7 4"
      padding-lg="7 6"
      bg="specialBackground"
      data-testid="expenses-footer-calculator"
    >
      <Grid preset="page" colsGap="0px">
        <Grid.Item colSpan="0-4" colSpan-sm="0-4" colSpan-md="0-6" colSpan-lg="0-6">
          <Flex height="100%" placeItems="center left">
            <Text as="h3" textStyle="heading5" align="left">
              Your total monthly expenses
            </Text>
          </Flex>
        </Grid.Item>
        <Grid.Item colSpan="5-8" colSpan-sm="5-8" colSpan-md="7-11" colSpan-lg="7-11">
          <div data-hj-suppress>
            <Text as="h2" textStyle="heading3" align="right" data-hj-suppress>
              ${formatNumber(totalMonthlyExpenses)}
            </Text>
          </div>
        </Grid.Item>
      </Grid>
    </Container>
  </LayoutContent>
);

const NZV2ExpenseFooter = ({ totalMonthlyExpenses }) => (
  <LayoutContent>
    <Container
      margin="4 0"
      padding="7 4"
      padding-lg="7 6"
      bg="specialBackground"
      data-testid="expenses-footer-calculator"
    >
      <Grid preset="page" colsGap="0px">
        <Grid.Item colSpan="0-4" colSpan-sm="0-4" colSpan-md="0-6" colSpan-lg="0-6">
          <Flex height="100%" placeItems="center left">
            <Text as="h3" textStyle="heading5" align="left">
              Your total monthly expenses
            </Text>
          </Flex>
        </Grid.Item>
        <Grid.Item colSpan="5-8" colSpan-sm="5-8" colSpan-md="7-11" colSpan-lg="7-11">
          <div data-hj-suppress>
            <Text as="h2" textStyle="heading3" align="right" data-hj-suppress>
              $ {formatNumber(totalMonthlyExpenses)}
            </Text>
          </div>
        </Grid.Item>
      </Grid>
    </Container>
  </LayoutContent>
);
